// Hero Slider - Optimized
(function() {
  'use strict';

  // 使用 IntersectionObserver 延迟初始化
  function initSliders() {
    const sliders = document.querySelectorAll('.hero-slider .swiper');

    sliders.forEach(function(container) {
      // 检查是否已初始化
      if (container.swiper) return;

      const section = container.closest('.hero-slider-section');
      if (!section) return;

      // 获取配置参数
      const loop = container.dataset.loop === 'true';
      const autoplayDelay = parseInt(container.dataset.autoplay, 10) || 0;

      new Swiper(container, {
        slidesPerView: 1.1,
        centeredSlides: true,
        navigation: {
          nextEl: container.querySelector('.swiper-button-next'),
          prevEl: container.querySelector('.swiper-button-prev'),
        },
        scrollbar: {
          el: container.querySelector('.hero-slider__scrollbar'),
          draggable: true,
        },
        loop: loop,
        autoplay: autoplayDelay > 0 ? {
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        } : false,
        speed: 700,
        breakpoints: {
          0: {
            slidesPerView: 1.08,
            spaceBetween: parseInt(container.dataset.gapMobile, 10) || 16,
          },
          640: {
            slidesPerView: 1.2,
            spaceBetween: parseInt(container.dataset.gapMobile, 10) || 16,
          },
          768: {
            slidesPerView: 1.2,
            spaceBetween: parseInt(container.dataset.gapDesktop, 10) || 24,
          },
          1024: {
            slidesPerView: 1.2,
            spaceBetween: parseInt(container.dataset.gapDesktop, 10) || 24,
          },
          1280: {
            slidesPerView: 1.25,
            spaceBetween: parseInt(container.dataset.gapDesktop, 10) || 24,
          }
        },
        // 性能优化：只渲染可见的 slide
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
      });
    });
  }

  // ===== 使用 IntersectionObserver 延迟初始化 =====
  function observeSliders() {
    const sliders = document.querySelectorAll('.hero-slider .swiper');

    if (!('IntersectionObserver' in window)) {
      // 降级方案：直接初始化
      initSliders();
      return;
    }

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const container = entry.target;
          // 检查是否已初始化
          if (!container.swiper) {
            // 触发初始化
            const event = new CustomEvent('slider-visible', { detail: { container: container } });
            document.dispatchEvent(event);
          }
          // 保持观察，以便在重新进入视口时再次初始化（但 Swiper 已存在）
        }
      });
    }, {
      rootMargin: '200px', // 提前 200px 开始加载
      threshold: 0.01,
    });

    sliders.forEach(function(slider) {
      observer.observe(slider);
    });

    // 监听自定义事件进行初始化
    document.addEventListener('slider-visible', function(e) {
      const container = e.detail.container;
      if (container && !container.swiper) {
        // 触发初始化
        const section = container.closest('.hero-slider-section');
        if (section) {
          // 模拟数据加载
          initSliders();
        }
      }
    });
  }

  // ===== DOM 加载完成后初始化 =====
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSliders);
  } else {
    observeSliders();
  }

})();